import { oc } from "../../../../date-fns/locale/oc.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    oc
  }
};